export const EMPTY_NOTE: CMxCommonApp.DecoratedNote = {
  description: '',
  content: '',
  filename: '',
  type: '',
  document_id: null,
  id: null,
  segments: [],
  spans: [],
  documentNotices: [],
  unique_document_number: ''
};
